exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".week-base-page[data-v-35acbc32] .el-date-editor .el-range-separator{width:8%}\n", ""]);

// exports
